import { render, staticRenderFns } from "./InspectorTeam.vue?vue&type=template&id=4a703434&"
import script from "./InspectorTeam.vue?vue&type=script&lang=js&"
export * from "./InspectorTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports